module.exports = __webpack_public_path__ + "static/media/DocumentSelfieExample.dc928849.svg";